import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import { Modal } from '@gitbook/react-uikit';

import { GitSyncLogoStatus } from './GitSyncLogoStatus';
import { GitSyncProgressModalStepper } from './GitSyncProgressModalStepper';
import type { GitSyncCurrentStatus } from './useGitSyncCurrentStatus';

/**
 * Modal that displays the progress stages of the Git synchronization
 * through a vertical stepper.
 */
export function GitSyncProgressModal(props: {
    space: api.Space;
    installationProvider: api.GitSyncProvider;
    gitSyncStatus: GitSyncCurrentStatus | null;
    onClose: () => void;
}): React.ReactElement {
    const { space, installationProvider, gitSyncStatus, onClose } = props;

    return (
        <Modal size="large" onClose={onClose}>
            <div className="flex flex-col">
                {/* Header */}
                <div className="flex flex-col border-b p-4">
                    <GitSyncLogoStatus
                        provider={installationProvider}
                        state={
                            gitSyncStatus?.state === 'failure' ||
                            gitSyncStatus?.state === 'timed-out'
                                ? 'failure'
                                : gitSyncStatus?.state === 'success'
                                  ? 'success'
                                  : 'running'
                        }
                    />
                </div>
                <div className="mx-auto my-10 w-3/4">
                    <GitSyncProgressModalStepper space={space} gitSyncStatus={gitSyncStatus} />
                </div>
            </div>
        </Modal>
    );
}
